<template>
  <div>
    <v-data-table
      v-bind="$attrs"
      v-on="$listeners"
      v-model="innerSelected"
      :options.sync="innerOptions"
      loading-text="Loading... Please wait"
      :footer-props="innerFooterProps"
      @update:page="movePage"
      @update:sort-by="movePage"
      @update:multi-sort-by="movePage"
      @update:sort-desc="movePage"
      @update:items-per-page="movePage"
      :mobile-breakpoint="mobileBreakpoint"
    >
      <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
        <slot :name="slot" v-bind="scope" />
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    options: Object,
    footerProps: {
      type: Object,
      default: function () {
        return {
          itemsPerPageOptions: [5, 10, 25, 50, 100],
        };
      },
    },
    mobileBreakpoint: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      // innerOptions: {
      //   page: 1,
      //   itemsPerPage: 5,
      // },
      innerOptions: this.options,
      innerSelected: this.selected,
      innerFooterProps: this.footerProps,
    };
  },
  computed: {
    apiParams() {
      return {
        page: this.innerOptions.page - 1,
        // size: this.innerOptions.itemsPerPage,
        size: this.setItemsPerPage(),
        sort: this.getSortGroup(),
      };
    },
  },
  methods: {
    setItemsPerPage() {
      if (!this.innerOptions.itemsPerPage) {
        this.innerOptions.itemsPerPage = this.footerProps[
          "itemsPerPageOptions"
        ][0];
      }
      return this.innerOptions.itemsPerPage;
    },
    getSortGroup() {
      let sortGroup = [];
      if (this.innerOptions.sortBy) {
        this.innerOptions.sortBy.forEach((v, i) => {
          sortGroup.push(
            `${v},${this.innerOptions.sortDesc[i] ? "desc" : "asc"}`
          );
        });
      }
      return sortGroup;
    },
    async movePage() {
      this.innerOptions.apiParams = this.apiParams;
      await this.$emit("movePage");
    },
  },
  watch: {
    // Handles internal model changes.
    innerSelected(newVal) {
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    selected(newVal) {
      this.innerSelected = newVal;
    },
    options(v) {
      this.innerOptions = v;
    },
    // innerOptions(v) {
    //   this.$emit("update:options", v);
    // }
  },
  async created() {
    this.innerOptions.apiParams = this.apiParams;
    if (this.selected) {
      this.innerSelected = this.selected;
    }
  },
};
</script>


<style>
/* .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    color: black;
    background-color: #CFD8DC;
    text-align: center;
} */
</style>